var React = require('react');

function CalendarCalendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 1C11 0.447715 10.5523 0 10 0C9.44771 0 9 0.447715 9 1H3C3 0.447715 2.55228 0 2 0C1.44772 0 1 0.447715 1 1H0V12H12V1H11ZM2 10V5H10V10H2Z","fill":"currentColor"}));
}

CalendarCalendar.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CalendarCalendar;

CalendarCalendar.default = CalendarCalendar;
